import { Link } from "react-router-dom";
import { LogoMark, LogoWordmark } from "@/components/Logo";
import { useLang } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-night text-sand/80" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <LogoMark size={36} />
            <LogoWordmark dark tagline />
          </div>
          <p className="text-sm leading-relaxed text-sand/60 max-w-xs">{t("footer.tagline")}</p>
        </div>
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-gold mb-5">{t("footer.explore")}</p>
          <div className="flex flex-col gap-3 text-sm">
            <Link to="/" data-testid="footer-villa-link" className="hover:text-gold transition-colors">{t("nav.villa")}</Link>
            <Link to="/excursions" data-testid="footer-excursions-link" className="hover:text-gold transition-colors">{t("nav.experiences")}</Link>
            <Link to="/restaurants" data-testid="footer-restaurants-link" className="hover:text-gold transition-colors">{t("nav.dining")}</Link>
            <Link to="/services" data-testid="footer-services-link" className="hover:text-gold transition-colors">{t("nav.services")}</Link>
            <Link to="/blog" data-testid="footer-blog-link" className="hover:text-gold transition-colors">{t("nav.blog")}</Link>
            <a href="/#faq" data-testid="footer-faq-link" className="hover:text-gold transition-colors">{t("footer.faq")}</a>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-gold transition-colors">{t("footer.terms")}</Link>
          </div>
        </div>
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-gold mb-5">{t("footer.contact")}</p>
          <div className="flex flex-col gap-3 text-sm">
            <a href="mailto:villaparaisocabarete@gmail.com" data-testid="footer-email-link" className="hover:text-gold transition-colors">villaparaisocabarete@gmail.com</a>
            <span className="text-sand/50">Cabarete, Puerto Plata, DR</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-sand/40">
          <span>© {new Date().getFullYear()} {t("footer.rights")}</span>
          <span className="font-serif italic">{t("footer.quote")}</span>
        </div>
      </div>
    </footer>
  );
}
